import { render, staticRenderFns } from "./DoctorCardCalendar.vue?vue&type=template&id=3477a600&"
import script from "./DoctorCardCalendar.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCardCalendar.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3477a600')) {
      api.createRecord('3477a600', component.options)
    } else {
      api.reload('3477a600', component.options)
    }
    module.hot.accept("./DoctorCardCalendar.vue?vue&type=template&id=3477a600&", function () {
      api.rerender('3477a600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorCardCalendar.vue"
export default component.exports